<template>
  <div class="artwork-shipping-progress js-pdp-shipping-progress-bar-wrapper">
    <div
      class="artwork-shipping-progress__bar-tile artwork-shipping-progress__bar-tile--complete js-pdp-shipping-progress-bar-complete hidden"
    >
      <div class="artwork-shipping-progress__bar-icon-wrap">
        <UseSvg
          icon="free-shipping-truck"
          class="artwork-shipping-progress__shipping-progress-bar-icon-complete"
          width="60"
          height="30"
        />
      </div>
      <span class="artwork-shipping-progress__bar-text-complete">Free Shipping!</span>
    </div>

    <div
      class="artwork-shipping-progress__bar-tile artwork-shipping-progress__bar-tile--shortfall js-pdp-shipping-progress-bar-shortfall hidden"
    >
      <div class="artwork-shipping-progress__shipping-progress-bar-icon-wrap">
        <UseSvg
          icon="fast-delivery"
          class="artwork-shipping-progress__bar-icon-delivery"
          width="34"
          height="34"
        />
      </div>
      <span class="artwork-shipping-progress__bar-text">
        <span class="artwork-shipping-progress__bar-total js-pdp-shipping-progress-bar-amount">
          <!-- $6.44 -->
        </span>
        from free shipping
      </span>
      <div
        class="progress-bar artwork-shipping-progress__shipping-progress-bar js-pdp-shipping-progress-bar"
        :data-currency-sign="currencySign"
      >
        <span>{{ currencySign }}0</span>
        <div class="progress-bar__line-wrap">
          <div class="progress-bar__line js-pdp-shipping-progress-bar-line"></div>
        </div>
        <span class="js-pdp-shipping-progress-bar-threshold" />
      </div>
    </div>
  </div>
</template>

<script>
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "ArtworkShippingProgress",
  components: { UseSvg },
  setup() {
    return {
      currencySign: "$"
    };
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-shipping-progress {
  width: 100%;
  text-align: center;
  margin-left: auto;

  @include with-large-desktop {
    width: auto;
  }

  &__bar-tile {
    margin-top: 28px;
    padding: 4px;
    border-radius: 8px;
    background-color: $section-grey;

    @include with-large-desktop {
      margin: 0 16px 0 0;
      padding: 0;
      border-radius: 0;
      background-color: unset;
    }

    &--complete {
      display: flex;
      align-items: center;
      justify-content: center;

      @include with-large-desktop {
        display: block;
        width: 116px;
      }
    }

    &--shortfall {
      @include with-large-desktop {
        width: 100px;
      }
    }
  }

  &__bar-icon-wrap {
    margin-right: 5px;

    @include with-large-desktop {
      margin-right: 0;
    }
  }

  &__bar-text-complete {
    color: $feedback-success-darker;
    font-size: 16px;
    font-weight: 700;
  }

  &__shipping-progress-bar-icon-wrap {
    margin-bottom: 4px;
  }

  &__bar-icon-delivery {
    color: $blue;
  }

  &__bar-total {
    font-weight: 700;
  }

  &__shipping-progress-bar {
    margin: 4px 24px 0;

    @include with-large-desktop {
      display: none;
    }
  }
}
</style>
